import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance, onMounted, ref, watch } from 'vue';
import AppSidebar from '@/components/global/sidebar/AppSidebar.vue';
import Tasks from '@/views/Tasks.vue';
import Comments from '@/views/Comments.vue';
import ReportRepository from '@/modules/Statistics/api/repositories/ReportRepository';
import { StatisticsCmsColumns } from '@/interfaces/components/cms/StatisticsCmsColumns';
import CMSUserRepository from '@/repositories/CMSUserRepository';
import { ReportTimeFrame } from '@/modules/Statistics/interfaces/ReportTimeFrame';

interface Props {
    sidebarData: any;
    isEdit: boolean;
    timeFrame: ReportTimeFrame;
    userId: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StatisticsSidebar',
  props: {
    sidebarData: null,
    isEdit: { type: Boolean },
    timeFrame: null,
    userId: null
  },
  emits: ["addNewReport", "filterDashboardReportsByDateAndUser", "filterDashboardReportsByDate", "isEditChange"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'addNewReport', report: StatisticsCmsColumns | undefined, size: string): void;
    (e: 'filterDashboardReportsByDateAndUser', userId: string): void;
    (e: 'filterDashboardReportsByDate'): void;
    (e: 'isEditChange', isEdit: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    sidebarData: any;
    isEdit: boolean;
    timeFrame: ReportTimeFrame;
    userId: string;
};





const { proxy } = getCurrentInstance()!;

const reportId = ref<string>('');
const reportSize = ref<string>('');
const currentlySelectedUser = ref<string>('1');

const reportList = computed<StatisticsCmsColumns[]>(() => {
    return ReportRepository.getAll();
});

const allUsers = computed(() => {
    return CMSUserRepository.getAllExceptArchivedUsers();
});

const years = computed(() => {
    // return array of years from 2000 to current year
    const result = [];
    for (let i = 2000; i <= new Date().getFullYear(); i++) {
        result.push(i);
    }
    return result.reverse();
});

const weeks = computed(() => {
    // return array of weeks from 1 to 52 and add current string as first value in array
    const result: Array<string | number> = ['Current'];
    for (let i = 1; i <= 52; i++) {
        result.push(i);
    }
    return result;
});

const months = computed(() => {
    // return array of months from 1 to 12 and add / string as first value in array
    const result: Array<string | number> = ['/'];
    for (let i = 1; i <= 12; i++) {
        result.push(i);
    }
    return result;
});

function isReportDataValid() {
    if (!reportId.value) {
        (proxy as any).$notification.error({
            message: proxy?.$t('No report selected!'),
            description: '',
        });
        return false;
    }

    if (!reportSize.value) {
        (proxy as any).$notification.error({
            message: proxy?.$t('Please select report size!'),
            description: '',
        });
        return false;
    }

    return true;
}

function addNewReport() {
    if (!isReportDataValid()) {
        return;
    }

    const report = reportList.value.find((reportItem) => reportItem.id === reportId.value);

    emit('addNewReport', report, reportSize.value);
}

function filterDashboardReportsByDateAndUser() {
    emit('filterDashboardReportsByDateAndUser', currentlySelectedUser.value);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function filterDashboardReportsByDate() {
    emit('filterDashboardReportsByDate');
}

onMounted(() => {
    currentlySelectedUser.value = props.userId;
});

watch(
    () => props.isEdit,
    () => {
        emit('isEditChange', props.isEdit);
    },
);

return { __sfc: true,props, emit, proxy, reportId, reportSize, currentlySelectedUser, reportList, allUsers, years, weeks, months, isReportDataValid, addNewReport, filterDashboardReportsByDateAndUser, filterDashboardReportsByDate, AppSidebar, Tasks, Comments }
}

})